/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Zadejte tyto kódy slevy při placení na ${i.storeName} a užijte si výjimečné slevy na online nákupy.`
};

const da_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Indtast disse rabatkoder, når du gennemfører din ordre hos ${i.storeName}, og få ekstra rabat på dine onlinekøb.`
};

const de_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Geben Sie diese Rabattcodes beim Bestellvorgang auf ${i.storeName} ein und profitieren Sie von exklusiven Rabatten.`
};

const en_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Enter these discount codes when placing your order on ${i.storeName}, and benefit from exceptional discounts on your online purchases.`
};

const es_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Introduce estos códigos de descuento al realizar tu pedido en ${i.storeName} y disfruta de descuentos excepcionales en tus compras online.`
};

const fr_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Saisissez ces codes de réduction lors du passage de votre commande sur ${i.storeName}, et profitez de remises exceptionnelles sur vos achats en ligne.`
};

const hu_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Írja be ezeket a rabatt kódokat a ${i.storeName} -on végzett fizetéskor, és élvezze az lenyűgöző kedvezményeket az online vásárlásakor.`
};

const it_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Inserisci questi codici sconto al momento dell'ordine su ${i.storeName} e approfitta di sconti eccezionali sui tuoi acquisti online.`
};

const nl_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Voer deze kortingscodes in bij het afrekenen op ${i.storeName} en ontvang direct korting op je online aankopen.`
};

const pl_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Wpisz te kody podczas składania zamówienia w ${i.storeName} i korzystaj z wyjątkowych rabatów.`
};

const pt_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Digite estes códigos de desconto ao finalizar sua compra na ${i.storeName} e aproveite descontos excepcionais em suas compras online.`
};

const sv_discount_codes_instruction = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Ange dessa rabattkoder när du slutför din beställning hos ${i.storeName} och få exklusiva rabatter online.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ storeName: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_instruction = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_instruction(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_instruction", locale)
	if (locale === "cs") return cs_discount_codes_instruction(inputs)
	if (locale === "da") return da_discount_codes_instruction(inputs)
	if (locale === "de") return de_discount_codes_instruction(inputs)
	if (locale === "en") return en_discount_codes_instruction(inputs)
	if (locale === "es") return es_discount_codes_instruction(inputs)
	if (locale === "fr") return fr_discount_codes_instruction(inputs)
	if (locale === "hu") return hu_discount_codes_instruction(inputs)
	if (locale === "it") return it_discount_codes_instruction(inputs)
	if (locale === "nl") return nl_discount_codes_instruction(inputs)
	if (locale === "pl") return pl_discount_codes_instruction(inputs)
	if (locale === "pt") return pt_discount_codes_instruction(inputs)
	return sv_discount_codes_instruction(inputs)
};
export { discount_codes_instruction as "discount_codes.instruction" }